/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ModificationTimestamp
 */
export interface ModificationTimestamp {
    /**
     * 
     * @type {string}
     * @memberof ModificationTimestamp
     */
    groupName: string;
    /**
     * 
     * @type {Date}
     * @memberof ModificationTimestamp
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the ModificationTimestamp interface.
 */
export function instanceOfModificationTimestamp(value: object): value is ModificationTimestamp {
    if (!('groupName' in value) || value['groupName'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function ModificationTimestampFromJSON(json: any): ModificationTimestamp {
    return ModificationTimestampFromJSONTyped(json, false);
}

export function ModificationTimestampFromJSONTyped(json: any, ignoreDiscriminator: boolean): ModificationTimestamp {
    if (json == null) {
        return json;
    }
    return {
        
        'groupName': json['groupName'],
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function ModificationTimestampToJSON(json: any): ModificationTimestamp {
    return ModificationTimestampToJSONTyped(json, false);
}

export function ModificationTimestampToJSONTyped(value?: ModificationTimestamp | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'groupName': value['groupName'],
        'updatedAt': value['updatedAt'].toISOString(),
    };
}

